@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Maine</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div class="axis-form-group _mt-medium"
      [ngClass]="{
              'has-axis-required':
               reactiveForm.get(controls[0].formControlName)?.value === '' ||
               reactiveForm.get(controls[0].formControlName)?.value === null,
               'has-axis-error':
                  reactiveForm.get(controls[0].formControlName)?.touched &&
                  reactiveForm.get(controls[0].formControlName)?.invalid,

            }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
              @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
              }
            }
        }
      </div>
      <div class="axis-grid">
        @if (baseRules["SelectCoverage_DropDown"]?.includes("show")) {
          <div class="axis-col-6">
            <div class="axis-form-group _mt-medium "
              [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(controls[1].formControlName)?.value === null ||
                      reactiveForm.get(controls[1].formControlName)?.value === '',
                      'has-axis-error':
                  reactiveForm.get(controls[1].formControlName)?.touched &&
                  reactiveForm.get(controls[1].formControlName)?.invalid,
                    '_ml-xlarge': baseRules.Show_Indent,
                  }">
              <label
                class="axis-control-label"
                for="{{ controls[1].formControlName }}"
                >
                @if(baseRules?.Show_Fixed_Dropdown_label === 'Yes') {
                  {{ textValues?.Fixed_Dropdown_Text }}
                }@if(baseRules?.Show_Fixed_Dropdown_label !== 'Yes') {
                  {{ controls[1].label }}
                }
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                ></label
              >
              <axis-dropdown
                [dataProvider]="controls[1].data"
                id="{{ controls[1].formControlName }}"
                formControlName="{{ controls[1].formControlName }}"
              ></axis-dropdown>
               @if (reactiveForm.get(controls[1].formControlName)?.touched) {
              @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <span class="axis-error-block">Please select an option.</span>
              }
            }
            </div>
          </div>
        }
      </div>
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Maine</h2>
  @if (baseRules?.Reject_Medical_Payment_Text_Value === "show") {
    <div class="axis-form-group">
      <label class="axis-control-label">{{ textValues?.Reject_Medical_Payment_Text }}</label>
    </div>
  }
}